import {BaseButton, BaseSelect} from "@/components";

interface ProviderMethodFiltersProps {
  countryFilter: string;
  providerFilter: string;
  operationFilter: string;
  activeFilter: string;
  onCountryChange: (v: string) => void;
  onProviderChange: (v: string) => void;
  onOperationChange: (v: string) => void;
  onActiveChange: (v: string) => void;
  onReset: () => void;
}

const countryOptions = [
  {value: "all", label: "Todos los países"},
  {value: "CO", label: "Colombia"},
  {value: "CL", label: "Chile"},
  {value: "PE", label: "Perú"},
  {value: "MX", label: "México"},
  {value: "GLOBAL", label: "Global"},
];

const providerOptions = [
  {value: "all", label: "Todos los proveedores"},
  {value: "zpay24_pk", label: "ZPay24 PK"},
  {value: "zpay24_tdp", label: "ZPay24 TDP"},
  {value: "zpay24_bnc", label: "ZPay24 BNC"},
  {value: "paycash", label: "PayCash"},
  {value: "stripe", label: "Stripe"},
];

const operationOptions = [
  {value: "all", label: "Todas las operaciones"},
  {value: "deposit", label: "Depósito"},
  {value: "withdrawal", label: "Retiro"},
];

const activeOptions = [
  {value: "all", label: "Todos los estados"},
  {value: "true", label: "Activo"},
  {value: "false", label: "Inactivo"},
];

export const ProviderMethodFilters = ({
  countryFilter,
  providerFilter,
  operationFilter,
  activeFilter,
  onCountryChange,
  onProviderChange,
  onOperationChange,
  onActiveChange,
  onReset,
}: ProviderMethodFiltersProps) => {
  const hasFilters =
    countryFilter !== "all" || providerFilter !== "all" || operationFilter !== "all" || activeFilter !== "all";

  return (
    <div className="flex flex-wrap items-end gap-4">
      <div className="min-w-40">
        <BaseSelect
          label="País"
          options={countryOptions}
          value={countryFilter}
          onChange={e => onCountryChange(e.target.value)}
        />
      </div>
      <div className="min-w-45">
        <BaseSelect
          label="Proveedor"
          options={providerOptions}
          value={providerFilter}
          onChange={e => onProviderChange(e.target.value)}
        />
      </div>
      <div className="min-w-45">
        <BaseSelect
          label="Operación"
          options={operationOptions}
          value={operationFilter}
          onChange={e => onOperationChange(e.target.value)}
        />
      </div>
      <div className="min-w-40">
        <BaseSelect
          label="Estado"
          options={activeOptions}
          value={activeFilter}
          onChange={e => onActiveChange(e.target.value)}
        />
      </div>
      {hasFilters && (
        <BaseButton
          variant="ghost"
          size="sm"
          onClick={onReset}
        >
          Limpiar filtros
        </BaseButton>
      )}
    </div>
  );
};
